"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(event) {
    return ['LATENCY', 'GRAPH', event];
}
exports.transformArguments = transformArguments;
